import i18n from './index';

/**
 * Maps API error messages (English) to i18n keys.
 * Add any new error returned by the backend here.
 */
const ERROR_KEYS = {
  'Refresh token required.':                                    'refresh_token_required',
  'Invalid or already revoked token.':                          'invalid_token',
  'Successfully logged out.':                                   'logged_out',
  'Invalid credentials.':                                       'invalid_credentials',
  'No active account found with the given credentials.':        'no_active_account',
  'user with this email already exists.':                       'email_already_exists',
  'Disposable email addresses are not allowed. Please use a permanent email.': 'disposable_email',
  'Invalid credits amount.':                                    'invalid_credits',
  'You already have an active subscription.':                   'already_subscribed',
  'No active subscription.':                                    'no_subscription',
  'Stripe not configured.':                                     'stripe_not_configured',
  'Insufficient credits.':                                      'insufficient_credits',
  'Monthly limit of':                                           'monthly_limit_reached',
  'Session not found or incomplete':                            'session_not_found',
  'No generated file':                                          'no_generated_file',
  'This file type already exists in this declaration.':         'file_type_exists',
  'File type not allowed for this declaration type.':           'file_type_not_allowed',
  'This file cannot be reset to draft.':                        'cannot_reset_to_draft',
  'Not found':                                                  'not_found',
  'File must be in "Ready" status to be sent for signature.':   'file_not_ready',
  'No generated file for this document.':                       'no_file_for_document',
  'At least one signatory is required.':                        'signatory_required',
  'Each signatory must have an email address.':                 'signatory_email_required',
  'All files must be in "Signatures confirmed" status.':        'all_files_must_be_signed',
  'No generated files.':                                        'no_files',
  'No audio file provided.':                                    'no_audio_provided',
  'No audio file.':                                             'no_audio',
  'Unsupported format':                                         'unsupported_format',
  'Invalid or expired token.':                                  'invalid_verification_token',
  'Token is required.':                                         'token_required',
  'Email already verified.':                                    'email_already_verified',
  'Email verified successfully!':                               'email_verified_success',
  'Verification email sent successfully.':                      'verification_email_sent',
  'Email not verified. Please check your inbox.':               'email_not_verified',
  'Maximum number of sessions reached for this document type':  'max_sessions_reached',
  'This co-edition contract cannot be generated: no corporate editor (role E) is associated with this declaration.': 'coedition_no_editor_e',
  'No contract is needed: the artist is self-published (their own EACA).': 'self_published_no_contract',
  'This field may not be blank.':                               'field_required',
  'Password must be at least 8 characters.':                    'password_too_short',
  'This password must contain at least one special character.': 'password_no_special_char',
  'This password must contain at least one digit.':             'password_no_digit',
  'Token has expired. Please request a new one.':               'password_reset_expired',
  'Session not found.':                                         'inject_session_not_found',
  'Session is already complete.':                               'inject_session_complete',
  'role and name are required.':                                'inject_missing_fields',
  'Invalid role:':                                              'inject_invalid_role',
  'This rights holder is already in the session.':              'inject_duplicate',
  'Subject is required.':                                       'support_subject_required',
  'Message is required.':                                       'support_message_required',
  'This ticket is closed.':                                     'support_ticket_closed',
};

/**
 * Translates an API error message into the current language.
 */
export function t(message) {
  if (!message) return message;
  for (const [apiMsg, key] of Object.entries(ERROR_KEYS)) {
    if (message.includes(apiMsg)) return i18n.t(`errors:${key}`);
  }
  return message;
}

/**
 * Extracts and translates the error message from an axios response.
 */
export function apiError(err, fallback) {
  const msg = err?.response?.data?.error || err?.message;
  if (msg) return t(msg);
  return fallback || i18n.t('errors:generic');
}
